export const environment = {
  production: false,
  name: 'v2-mock',
  apiUrl: 'https://api.v2.airgateway.site/',
  keycloakUrl: 'https://auth.airgateway.work',
  tracerUrl: 'https://tracer-api.v2.airgateway.site',
  bpBackendUrl: 'https://backend.v2.bookingpad.site',
  bpUrl: 'https://web.v2.bookingpad.site/',
};
